/**
 * Reviews domain — admin UI registration (Sub-project III, Task 8).
 *
 * A single ReviewActions component handles both UserReview and EventReview
 * by reading the current route's modelLabel to select the correct endpoint
 * prefix (user-reviews/ vs event-reviews/).
 */
import { registerAdminUI } from '@/admin/generic/registry';
import ReviewActions from './components/ReviewActions.vue';

registerAdminUI('reviews.userreview', {
    slots: {
        detailHeader: ReviewActions,
    },
});

registerAdminUI('reviews.eventreview', {
    slots: {
        detailHeader: ReviewActions,
    },
});
